import { fetchLimitValue } from "../../routes/FetchData";
import { setLimit } from "../reducers/limitReducer";


export const updateLimit = (dispatch, id) => {
    fetchLimitValue(id).then((data) => {
        dispatch(setLimit(data.limit));
    });
 
};